module.exports = __webpack_public_path__ + "img/yl3060.ee169f95.png";